import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../Context/UserContext/UserContextProvider';
import { TeeMeasureLabel } from '../types/databaseTables/idealteemeasures';

const useStyles = makeStyles(() => ({
  '@keyframes gradient': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
  container: {
    position: 'relative',
    width: '100%',
    textAlign: 'initial',
  },
  button: {
    position: 'absolute',
    opacity: 0.85,
    zIndex: 100,
    background: `linear-gradient(
      -45deg, 
      #9c27b0, 
      #ba68c8,
      #9c27b0,
      #9c27b0
      )`,
    backgroundSize: '500%',
    animation: '$gradient 5s ease infinite',
    height: '100%',
    width: '100%',
    '&.MuiButton-text': {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: 'white',
    },
    '& span.MuiButton-label': {
      opacity: 1,
    },
  },
}));

interface NoMeasurementsOverlayProps {
  children: React.ReactNode;
}

export function NoMeasurementsOverlay({ children }: NoMeasurementsOverlayProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userDetailsState } = useContext(UserContext);
  // Check to see if any user idealteemeasures are greater than 0. If so, user measures exist.
  const idealMeasuresExist =
    Object.keys(userDetailsState.idealGarmentMeasurements).reduce<number>(
      (sumOfMeasures: number, measureLabel: string) =>
        sumOfMeasures + (userDetailsState.idealGarmentMeasurements[measureLabel as TeeMeasureLabel] || 0 ),
      0
    ) > 0;

  return (
    <div className={classes.container}>
      {/* If no user measures exist, show a button overlay to take user to the User Measures Page. */}
      <Button
        onClick={() => navigate('/inputusermeasurements/inputidealteemeasurements')}
        size='large'
        className={classes.button}
        style={{ display: !idealMeasuresExist ? 'block' : 'none' }}
      >
        Add Your Ideal Measurements To Use This Feature
      </Button>
      {children}
    </div>
  );
}
